module.exports = __webpack_public_path__ + "media/images/favicons_staging/android-chrome-384x384-a634b391dd0d5e8274443450b01e3801.png";